import React from "react";
import { Link } from "react-router-dom";

const LandingPages = () => {
  return (
    <div className="p-5 pt-4 landing-pages-link">
      <h5>Landing Pages</h5>
      <div className="landing-boxes">
        <h6>Facebook</h6>
        <Link
          to={"https://americantaxsettlement.com/facebook-subscribe-form"}
          target="blank"
        >
          https://americantaxsettlement.com/facebook-subscribe-form
        </Link>
      </div>
      <div className="landing-boxes">
        <h6>Instagram</h6>
        <Link
          to={"https://americantaxsettlement.com/instagram-subscriber-form"}
          target="blank"
        >
          https://americantaxsettlement.com/instagram-subscriber-form
        </Link>
      </div>
      <div className="landing-boxes">
        <h6>Twitter</h6>
        <Link
          to={"https://americantaxsettlement.com/twitter-subscriber-form"}
          target="blank"
        >
          https://americantaxsettlement.com/twitter-subscriber-form
        </Link>
      </div>
      <div className="landing-boxes">
        <h6>Youtube</h6>
        <Link
          to={"https://americantaxsettlement.com/youtube-subscriber-form"}
          target="blank"
        >
          https://americantaxsettlement.com/youtube-subscriber-form
        </Link>
      </div>
      <div className="landing-boxes">
        <h6>Tiktok</h6>
        <Link
          to={"https://americantaxsettlement.com/tiktok-subscriber-form"}
          target="blank"
        >
          https://americantaxsettlement.com/tiktok-subscriber-form
        </Link>
      </div>
    </div>
  );
};

export default LandingPages;
